export enum PaymentStatus {
  APPROVED = "approved",
  AUTHORIZED = "authorized",
  IN_PROCESS = "in_process",
  PENDING = "pending",
  CANCELED = "canceled",
  CHARGED_BACK = "charged_back",
  IN_MEDIATION = "in_mediation",
  REFUNDED = "refunded",
  REJECTED = "rejected",
}

export enum PaymentType {
  MERCADOPAGO = "mercadopago",
  CASH = "cash",
  TRANSFER = "transfer",
}

export const PaymentStatusTranslations = {
  [PaymentStatus.APPROVED]: "Aprobado",
  [PaymentStatus.AUTHORIZED]: "Autorizado",
  [PaymentStatus.IN_PROCESS]: "En proceso",
  [PaymentStatus.PENDING]: "Pendiente",
  [PaymentStatus.CANCELED]: "Cancelado",
  [PaymentStatus.CHARGED_BACK]: "Contracargo",
  [PaymentStatus.IN_MEDIATION]: "En mediación",
  [PaymentStatus.REFUNDED]: "Reembolsado",
  [PaymentStatus.REJECTED]: "Rechazado",
} as const;

export const PaymentStatusColors = {
  [PaymentStatus.APPROVED]: "green",
  [PaymentStatus.AUTHORIZED]: "blue",
  [PaymentStatus.IN_PROCESS]: "yellow",
  [PaymentStatus.PENDING]: "yellow",
  [PaymentStatus.CANCELED]: "gray",
  [PaymentStatus.CHARGED_BACK]: "red",
  [PaymentStatus.IN_MEDIATION]: "orange",
  [PaymentStatus.REFUNDED]: "purple",
  [PaymentStatus.REJECTED]: "red",
} as const;

export interface Payment {
  id: number;
  team_id: number;
  competition_id: number;
  mercadopago_payment_id: number;
  payment_attempt_id: number;
  status: PaymentStatus;
  transaction_amount?: number;
  created_at: Date;
  updated_at: Date;
}

export const PaymentTypeColors = {
  [PaymentType.MERCADOPAGO]: "blue",
  [PaymentType.CASH]: "green", 
  [PaymentType.TRANSFER]: "orange",
};

export const PaymentTypeTranslations = {
  [PaymentType.MERCADOPAGO]: "MercadoPago",
  [PaymentType.CASH]: "Efectivo",
  [PaymentType.TRANSFER]: "Transferencia",
};

export interface PaymentWithDetails {
  payment_id: number;
  mercadopago_payment_id?: number;
  team_id: number;
  competition_id: number;
  payment_status: PaymentStatus;
  payment_type: PaymentType;
  payment_amount: number;
  payment_created_at: Date;
  payment_updated_at: Date;

  team_name: string;
  institution_id: number;
  institution_name: string;

  competition_name: string;

  registration_number?: string;
  team_number?: number;

  payment_attempt_amount?: number;
  check_in_url?: string;

  transfer_payment_id?: number;
  sender_first_name?: string;
  sender_last_name?: string;
  sender_cuit?: string;
  transfer_confirmation_status?: "pending" | "confirmed" | "rejected";
  transfer_confirmed_at?: Date;
  transfer_rejection_reason?: string;
  transfer_admin_notes?: string;
  transfer_confirmed_by_username?: string;

  cash_payment_id?: number;
  received_by?: number;
  received_by_username?: string;

  received_date?: Date;
  payer_first_name?: string;
  payer_last_name?: string;
  payer_dni?: string;
}